import React from "react";
import { Field, FieldArray } from "redux-form";
import {
    renderDollar,
    renderFieldDisabled,
    renderCurrency,
    renderFieldCheckCompact,
} from "../../../../../Utils/renderField/renderField";
import { renderField } from "../../../../../Utils/renderField/renderField";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";

const TableRow = ({ system, index, fields, change, years }) => {
    const isNew = fields.get(index).isNew;

    const handleCurrencySelection = (selectedCurrency) => {
        const isDollarSelected = selectedCurrency === "USD";
        change(`${system}.is_dollar`, isDollarSelected);
    };

    return (
        <React.Fragment key={index}>
            <tr key={`system-${index}`}>
                <td
                    className="text-center sin-borde-top"
                    style={{ width: "12%" }}
                >
                    <Field
                        name={`${system}.name`}
                        type="text"
                        component={isNew ? renderField : renderFieldDisabled}
                        className="form-control"
                        placeholder="Nuevo"
                    />
                </td>
                {years.slice(1).map((year) => (
                    <td key={year} style={{ width: "16%" }}>
                        <Field
                            name={`${system}.${year}`}
                            type="text"
                            component={
                                fields.get(index).is_dollar
                                    ? renderDollar
                                    : renderCurrency
                            }
                            className="form-control"
                            placeholder={
                                fields.get(index).is_dollar
                                    ? "$ 0.00"
                                    : "Q 0.00"
                            }
                        />
                    </td>
                ))}
                <td className="sin-borde-top" style={{ width: "20%" }}>
                    <Field
                        name={`${system}.is_iva_credit`}
                        component={renderFieldCheckCompact}
                        className="form-control"
                    />
                </td>
                <td
                    className="text-center sin-borde-top"
                    style={{ width: "15%", position: "relative" }}
                >
                    <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "5px" }}>
                            <UncontrolledDropdown>
                                <DropdownToggle
                                    tag="span"
                                    className="action_img"
                                    data-toggle="dropdown"
                                    aria-expanded={false}
                                >
                                    <img
                                        src={require("assets/img/icons/donate-coin.svg")}
                                        alt="Opciones"
                                        title="Opciones"
                                    />
                                </DropdownToggle>
                                <DropdownMenu
                                    container="body"
                                    style={{ width: "177px" }}
                                >
                                    <div className="br-top"></div>
                                    <DropdownItem
                                        onClick={() =>
                                            handleCurrencySelection("USD")
                                        }
                                    >
                                        USD
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() =>
                                            handleCurrencySelection("QUETZALES")
                                        }
                                    >
                                        QUETZALES
                                    </DropdownItem>
                                </DropdownMenu>
                                <div className="br-top"></div>
                            </UncontrolledDropdown>
                        </div>
                        <div>
                            <img
                                src={require("assets/img/icons/Accion-Eliminar.svg")}
                                alt="Borrar"
                                title="Borrar"
                                className="action_img"
                                onClick={() => {
                                    fields.remove(index);
                                }}
                            />
                        </div>
                    </div>
                </td>
            </tr>
        </React.Fragment>
    );
};

const GenericTable = ({ fields, dollar_exchange, change, years }) => {
    const calculateTotalForMonth = (month, isDollar) => {
        const allFields = fields.getAll() || [];
        let total = allFields.reduce((total, system) => {
            let value = parseFloat(system[month]) || 0;

            if (system.is_dollar) {
                value *= dollar_exchange;
            }

            return total + value;
        }, 0);
        if (isDollar && dollar_exchange) {
            total /= dollar_exchange;
        }
        return total;
    };

    const columnas =
        years && Array.isArray(years) && years.length > 0
            ? years.slice(1).map((year, index) => (
                  <th key={index + 1} style={{ width: "16%" }}>
                      {year}
                  </th>
              ))
            : null;

    return (
        <div className=" col-sm-12 form-group np-r p-0">
            <div className="table-responsive">
                <table className="table table-striped mb-0">
                    <thead>
                        <tr>
                            <th style={{ width: "10%" }}>CONCEPTO</th>
                            {columnas ? (
                                columnas
                            ) : (
                                <th colSpan="5">No hay datos disponibles</th>
                            )}
                            <th style={{ width: "16%" }}>¿Genera IVA?</th>
                            <th style={{ width: "10%" }}>ACCIONES</th>
                        </tr>
                    </thead>
                    <tbody style={{ backgroundColor: "#F0FFC7" }}>
                        {fields.map((system, index) => (
                            <TableRow
                                key={index}
                                system={system}
                                index={index}
                                fields={fields}
                                change={change}
                                years={years}
                            />
                        ))}
                        <tr
                            style={{
                                backgroundColor: "#F0FFC7",
                                borderBottom: "1px solid #035B2F",
                                borderTop: "1px solid #035B2F",
                            }}
                        >
                            <td className="custom-cell titulo-left-padded">
                                TOTALES Q
                            </td>
                            {years.slice(1).map((year, idx) => (
                                <td
                                    key={idx + 1}
                                    className="custom-cell text-right-padded"
                                >
                                    {new Intl.NumberFormat("es-GT", {
                                        style: "currency",
                                        currency: "GTQ",
                                    }).format(calculateTotalForMonth(year))}
                                </td>
                            ))}
                            <td></td>
                            <td></td>
                        </tr>
                        <tr style={{ backgroundColor: "#F0FFC7" }}>
                            <td className="custom-cell titulo-left-padded">
                                TOTALES $
                            </td>
                            {years.slice(1).map((year, idx) => (
                                <td
                                    key={idx + 1}
                                    className="custom-cell text-right-padded"
                                >
                                    {new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                    }).format(
                                        calculateTotalForMonth(year, true)
                                    )}
                                </td>
                            ))}
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="mt-2">
                <div
                    type="button"
                    className="btn btn-light btn-lg btn-block d-flex justify-content-end agregar-tab-generica"
                    onClick={() =>
                        fields.push({ isNew: true, is_dollar: true })
                    }
                >
                    AGREGAR
                </div>
            </div>
        </div>
    );
};

const InvestmentsDetailTable = ({
    dollar_exchange,
    allValues,
    change,
    years,
}) => {
    return (
        <div>
            <FieldArray
                name={`investments_budget_row`}
                dollar_exchange={dollar_exchange}
                component={GenericTable}
                allValues={allValues}
                change={change}
                years={years}
            />
        </div>
    );
};

const formName = "InvestmentsForm";

const selector = formValueSelector(formName);

const mapStateToProps = (state) => {
    const categoryBudget = selector(state, "investments_budget_row") || [];
    const allValues = categoryBudget.map((item) => item);
    return { allValues };
};

export default connect(mapStateToProps)(InvestmentsDetailTable);
